module.exports = __webpack_public_path__ + "img/Logo_Public_Senat.cb54d70e.svg";